const parseJwtPayload = (token?: string | null): Record<string, any> | null => {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    const base64Url = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64Url.padEnd(Math.ceil(base64Url.length / 4) * 4, '=');
    const json = atob(padded);
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const getTokenExpiryMs = (token?: string | null): number | null => {
  const payload = parseJwtPayload(token);
  if (!payload) {
    return null;
  }

  const value = typeof payload.expire === 'number'
    ? payload.expire
    : typeof payload.exp === 'number'
      ? payload.exp
      : null;

  if (!value || Number.isNaN(value)) {
    return null;
  }

  return value * 1000;
};

export const getTokenRemainingMs = (token?: string | null, nowMs: number = Date.now()): number | null => {
  const expiryMs = getTokenExpiryMs(token);
  if (!expiryMs) {
    return null;
  }

  return expiryMs - nowMs;
};

export const isTokenStale = (
  token?: string | null,
  staleWindowMs: number = 10 * 60 * 1000,
  nowMs: number = Date.now()
): boolean => {
  const remainingMs = getTokenRemainingMs(token, nowMs);
  if (remainingMs == null) {
    return true;
  }

  return remainingMs <= staleWindowMs;
};

export const isTokenFreshEnough = (
  token?: string | null,
  minRemainingMs: number = 10 * 60 * 1000,
  nowMs: number = Date.now()
): boolean => {
  const remainingMs = getTokenRemainingMs(token, nowMs);
  if (remainingMs == null) {
    return false;
  }

  return remainingMs > minRemainingMs;
};
